export default __webpack_public_path__ + "static/media/stripe_logo.24150a96.png";